var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.672 463.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7931a;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 231.836,
    cy: 231.836,
    r: 231.836,
    transform: "translate(-96.03 231.836) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.979,204.581c4.272-29.05-17.772-44.771-48.189-55.195l9.912-39.473-23.924-5.981-9.569,38.448c-6.323-1.538-12.816-3.076-19.309-4.443l9.569-38.619-23.923-5.98-9.74,39.3q-7.947-1.794-15.38-3.589v-.17l-33.15-8.2-6.323,25.632s17.43,4.016,17.43,4.272c9.74,2.393,11.449,8.886,11.107,14.013l-11.278,44.941a11.173,11.173,0,0,1,2.563.854,14.139,14.139,0,0,1-2.563-.683l-15.721,62.884c-1.2,2.9-4.272,7.348-10.936,5.639.17.342-17.43-4.272-17.43-4.272L127.163,301.47l31.271,7.86c5.81,1.538,11.449,2.905,17.088,4.443l-9.911,39.815,23.923,5.981,9.911-39.474c6.494,1.709,12.987,3.418,19.139,4.956l-9.74,39.3,23.923,5.981,9.911-39.815c41.011,7.69,71.77,4.614,84.586-32.467,10.423-29.733-.513-46.992-22.044-58.27C321.112,236.193,332.9,225.77,335.979,204.581Zm-54.853,76.9c-7.348,29.733-57.587,13.67-73.82,9.569l13.158-52.8C236.7,242.345,288.987,250.376,281.126,281.477Zm7.519-77.409c-6.835,27.17-48.53,13.329-62.03,9.911l11.962-47.847C252.077,169.55,295.651,175.873,288.645,204.068Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.69ba85130e6057fca5b01ba108033509.svg";
export { ForwardRef as ReactComponent };